import { Badge, FormControl, FormLabel, Switch, VStack } from '@elkaso-app/web-design';
import { useToggleContactVerificationApi } from 'apis/crm-brand-contact-details';
import { useCallback } from 'react';

export interface IStatusCell {
  isVerified: boolean;
  contactId: number;
}

export const StatusCell = ({ isVerified, contactId }: IStatusCell) => {
  // Self-contained mutation for toggling verification
  const { mutate: toggleVerification, isLoading: isToggling } = useToggleContactVerificationApi();

  // Memoized toggle handler
  const handleToggleVerification = useCallback(() => {
    toggleVerification({
      id: contactId,
      isVerified: !isVerified,
    });
  }, [toggleVerification, contactId, isVerified]);

  return (
    <VStack align='start' spacing={3}>
      <Badge colorScheme={isVerified ? 'green' : 'yellow'} variant='subtle' size='sm' borderRadius='md'>
        {isVerified ? 'Verified' : 'Pending Verification'}
      </Badge>

      <FormControl display='flex' alignItems='center' gap={2}>
        <Switch
          id={`verification-switch-${contactId}`}
          isChecked={isVerified}
          onChange={handleToggleVerification}
          isDisabled={isToggling}
          size='sm'
          colorScheme='green'
        />
        <FormLabel
          htmlFor={`verification-switch-${contactId}`}
          mb='0'
          fontSize='xs'
          color='gray.600'
          fontWeight='normal'>
          {isVerified ? 'Verified' : 'Verify'}
        </FormLabel>
      </FormControl>
    </VStack>
  );
};
